import { TrackingEvent } from '@manakincubber/tiime-tracking';

export const FORMALITY_SIGNED = 'Formality Signed';

export class FormalitySigned implements TrackingEvent {
  readonly name = FORMALITY_SIGNED;
}
